import React, { useState,useRef } from 'react'
import {localestr} from '../utils.js'

function NumberForm({capt1,capt2,number,setModal,action}){
    const [numb,setNumb]=useState(number)
    const targetRef = useRef()

    function addNumb(key){
      let val=numb
      if(key===-1&&val.length) val=val.substr(0,val.length-1)||0
      else if(key===-2) val=0
      else if(key===-1) val=(''+val).substring(0,-1)
      else if(val===0||val==='0') val=key
      else val+=''+key
      setNumb(val)
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function keyClick(e){
      if(e.key==='Enter') {action(numb);setModal('')}
      else if(e.key==='Escape') setModal('')
    }

    function setFocus(el){
      if (!el) return
      //if (!isActive) return
      //el.select()
      el.focus()
  }

    return(
        <div className='modal'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{capt1}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'>
            <div onKeyUp={keyClick} style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <label style={{display:'inline-flex', margin:'inherit', flexGrow:180, maxWidth:'360px'}} htmlFor="id3">
              <div style={{display:'inline-flex', minWidth:'60px', lineHeight:'24px', flexBasis:'60px', flexGrow:30}}>{capt2} </div>
              <input ref={el=>{setFocus(el);return targetRef}} style={{display:'inline-flex', width:'120px', boxSizing:'border-box', height:'24px', textAlign:'right', flexBasis:'120px', flexGrow:120}} id="id3" type="number" value={numb} onChange={e=>setNumb(parseFloat(e.target.value))}/>
            </label>  
            </div>
            <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(7)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>7</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(8)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>8</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(9)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>9</div></div>
            </div>
            <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(4)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>4</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(5)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>5</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(6)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>6</div></div>
            </div>
            <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(1)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>1</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(2)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>2</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(3)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>3</div></div>
            </div>
            <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(0)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>0</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb('.')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>.</div></div>
            <div style={{width:'50px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{addNumb(-2)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>C</div></div>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{action(numb);setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default NumberForm